var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 92,
	"./layouts/card/style.module.scss": 92,
	"./layouts/components/breadcrumbs": 115,
	"./layouts/components/breadcrumbs/": 115,
	"./layouts/components/breadcrumbs/index": 115,
	"./layouts/components/breadcrumbs/index.tsx": 115,
	"./layouts/components/breadcrumbs/style.module": 168,
	"./layouts/components/breadcrumbs/style.module.scss": 168,
	"./layouts/components/container": 42,
	"./layouts/components/container/": 42,
	"./layouts/components/container/index": 42,
	"./layouts/components/container/index.tsx": 42,
	"./layouts/components/container/style.module": 117,
	"./layouts/components/container/style.module.scss": 117,
	"./layouts/components/footer": 116,
	"./layouts/components/footer/": 116,
	"./layouts/components/footer/index": 116,
	"./layouts/components/footer/index.tsx": 116,
	"./layouts/components/footer/style.module": 83,
	"./layouts/components/footer/style.module.scss": 83,
	"./layouts/components/loading_indicator": 56,
	"./layouts/components/loading_indicator/": 56,
	"./layouts/components/loading_indicator/index": 56,
	"./layouts/components/loading_indicator/index.tsx": 56,
	"./layouts/components/nav_bar": 91,
	"./layouts/components/nav_bar/": 91,
	"./layouts/components/nav_bar/index": 91,
	"./layouts/components/nav_bar/index.tsx": 91,
	"./layouts/components/nav_bar/standalone": 321,
	"./layouts/components/nav_bar/standalone.tsx": 321,
	"./layouts/components/nav_bar/style.module": 33,
	"./layouts/components/nav_bar/style.module.scss": 33,
	"./layouts/components/notice_banner": 82,
	"./layouts/components/notice_banner/": 82,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 169,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 169,
	"./layouts/components/notice_banner/index": 82,
	"./layouts/components/notice_banner/index.tsx": 82,
	"./layouts/components/notice_banner/standalone": 322,
	"./layouts/components/notice_banner/standalone.tsx": 322,
	"./layouts/components/notice_banner/style.module": 170,
	"./layouts/components/notice_banner/style.module.scss": 170,
	"./layouts/page": 88,
	"./layouts/page/": 88,
	"./layouts/page/index": 88,
	"./layouts/page/index.tsx": 88,
	"./layouts/page/style.module": 84,
	"./layouts/page/style.module.scss": 84,
	"./layouts/types": 323,
	"./layouts/types.ts": 323,
	"./marketing/pages/home/toefl": 1600,
	"./marketing/pages/home/toefl/": 1600,
	"./marketing/pages/home/toefl/index": 1600,
	"./marketing/pages/home/toefl/index.tsx": 1600,
	"./marketing/pages/home/toefl/sections/ai": 1208,
	"./marketing/pages/home/toefl/sections/ai/": 1208,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1892,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1892,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1893,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1893,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1894,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1894,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1895,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1895,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1896,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1896,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1897,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1897,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1898,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1898,
	"./marketing/pages/home/toefl/sections/ai/index": 1208,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1208,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1899,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1899,
	"./marketing/pages/home/toefl/sections/apps": 1209,
	"./marketing/pages/home/toefl/sections/apps/": 1209,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1900,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1900,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1901,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1901,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1902,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1902,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1903,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1903,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1904,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1904,
	"./marketing/pages/home/toefl/sections/apps/index": 1209,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1209,
	"./marketing/pages/home/toefl/sections/features": 1210,
	"./marketing/pages/home/toefl/sections/features/": 1210,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1905,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1905,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1906,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1906,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1907,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1907,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1908,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1908,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1909,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1909,
	"./marketing/pages/home/toefl/sections/features/index": 1210,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1210,
	"./marketing/pages/home/toefl/sections/official_questions": 1214,
	"./marketing/pages/home/toefl/sections/official_questions/": 1214,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1918,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1918,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1214,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1214,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 750,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 750,
	"./marketing/pages/home/toefl/sections/value_props": 1211,
	"./marketing/pages/home/toefl/sections/value_props/": 1211,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1910,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1910,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1911,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1911,
	"./marketing/pages/home/toefl/sections/value_props/index": 1211,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1211,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2297,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2297,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1212,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1212,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1912,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1912,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1913,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1913,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1914,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1914,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1915,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1915,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1916,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1916,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1212,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1212,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 749,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 749,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1213,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1213,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1917,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1917,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1213,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1213,
	"./marketing/pages/home/toefl/style.module": 1919,
	"./marketing/pages/home/toefl/style.module.scss": 1919,
	"./marketing/pages/plans/toefl": 1601,
	"./marketing/pages/plans/toefl/": 1601,
	"./marketing/pages/plans/toefl/index": 1601,
	"./marketing/pages/plans/toefl/index.tsx": 1601,
	"./marketing/pages/plans/toefl/sections/testimonials": 1215,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1215,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1920,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1920,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1921,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1921,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1215,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2639;